const state = {
  items:[],
  checkOutStatus: null,
  services:{},
  otherServices:{},
  prices:null,
  msgServicios:''
}

const getters = {
  getBooking() {
    return state
  },
  findRefuge(state, idx) {
    const _ret = state.items.slice(idx,1)
    return _ret[0]
  },
  getServices(){
    return state.services
  },
  getOtherServices(){
    return state.otherServices
  },
  getJoinServices() {
    let rdo = {}
    let refs = Object.keys(state.services)

    refs.forEach( ref => {
      let days = Object.keys(state.services[ref])
      rdo[ref] = {}
      days.forEach( day => {
        rdo[ref][day] = []
        rdo[ref][day] = [ ...state.services[ref][day], ...state.otherServices[ref][day] ]
      })
    })
    return rdo
  }
}

const mutations = {
  appendRefuge(state, data){
    state.items.push(data.refuge)
    state.msgServicios = data.msgServicios
  },
  removeRefuge(state, idx){
    delete state.services[state.items[idx].booking]
    state.items.splice(idx,1)
  },

  createServices(state, data){
    state.services[data.reference] = {}
    state.otherServices[data.reference] = {}
    data.days.forEach( _d => {
      state.services[data.reference][ _d ] = []
      state.otherServices[data.reference][_d] = []
    })
  },
  clearServicesDay(state, data){
    state.services[data.reference][data.day] = []
  },
  clearOtherServicesDay(state, data){
    state.otherServices[data.reference][data.day] = []
  },
  appendService(state, data){
    let pos = state.services[data.reference][data.day].indexOf(data.service)
    if(pos === -1)
      state.services[data.reference][data.day].push(data.service)
    /*else
      state.services[data.reference][data.day].splice(pos, 1)*/
  },
  appendOtherService(state, data){
    let pos = state.otherServices[data.reference][data.day].indexOf(data.service)
    if(pos === -1)
      state.otherServices[data.reference][data.day].push(data.service)
    /*else
      state.otherServices[data.reference][data.day].splice(pos, 1)*/
  },
  removeService(state, data){
    let pos = state.services[data.reference][data.day].indexOf(data.service)
    if (pos !== -1) state.services[data.reference][data.day].splice(pos, 1)
  },
  setPrices(state, price){
    state.prices = price
  },
  cancelBooking(state){
    state.items = []
    state.checkOutStatus = null
    state.services = {}
    state.prices = null
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/_store/modules/booking.js